import { z } from "zod";

import {
  isPostgresStorableText,
  STORABLE_URL_RULE,
  toPostgresStorableText
} from "./postgres-storable-text";

/**
 * A string field whose text is made storable, then validated by `schema` again.
 * What the parse returns is the cleaned text.
 *
 * `schema` runs on both sides on purpose. On the input side it is what a
 * JSON-schema generator reads (`io: "input"` — the MCP tool schema and the CLI
 * projection), so the field keeps its `minLength`/`maxLength` there. On the
 * output side it re-checks the cleaned text, so a name made only of U+0000
 * fails `min(1)` instead of reaching a column as an empty name.
 *
 * Use it on a field a caller writes into a document column. A metadata value is
 * refused instead (`DOCUMENT_METADATA_VALUE_TEXT_RULE`): rewriting it would stop
 * it matching the filter its owner writes against it.
 */
export function storableText(schema: z.ZodString) {
  return schema.transform(toPostgresStorableText).pipe(schema);
}

/**
 * A URL field that refuses the characters Postgres cannot store. A URL is an
 * identifier, so it is refused rather than rewritten: a cleaned URL would point
 * somewhere the caller never named.
 */
export function storableUrl(schema: z.ZodString) {
  return schema.refine(isPostgresStorableText, STORABLE_URL_RULE);
}
